import { useEffect, useState } from "react";
import { CalendarClock, Loader2 } from "lucide-react";

/** Prazo automático: o cálculo vem SEMPRE do backend (motor único). */
export function DeliveryEstimateCard({ estimate, loading = false,
                                       testid = "delivery-estimate" }) {
  if (loading) {
    return (
      <div
        className="flex items-center gap-2 rounded-xl border border-white/10 bg-secondary/40 px-4 py-3 text-xs text-muted-foreground"
        data-testid={`${testid}-loading`}
      >
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        Calculando o prazo de produção e entrega...
      </div>
    );
  }
  if (!estimate?.label) {
    return (
      <div
        className="rounded-xl border border-white/10 bg-secondary/40 px-4 py-3 text-xs text-muted-foreground"
        data-testid={`${testid}-unavailable`}
      >
        Previsão de entrega: confirmamos com você no WhatsApp.
      </div>
    );
  }
  return (
    <div
      className="rounded-xl border border-brand/30 bg-brand/10 px-4 py-3"
      data-testid={testid}
    >
      <div className="flex items-center gap-2">
        <CalendarClock className="h-4 w-4 shrink-0 text-brand" />
        <p className="text-[11px] uppercase tracking-wide text-muted-foreground">
          Previsão de entrega
        </p>
      </div>
      <p className="mt-1 font-display text-lg first-letter:uppercase" data-testid={`${testid}-date`}>
        {estimate.label}
      </p>
      {/* Cliente e parceiro veem só a data. Detalhes operacionais (horas de impressão,
          fila das impressoras, margem) ficam nas telas internas de Produção. */}
    </div>
  );
}

/** Busca o prazo no backend sempre que `watch` mudar. */
export function useDeliveryEstimate(load, watch, enabled = true) {
  const [estimate, setEstimate] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!enabled) {
      setEstimate(null);
      return undefined;
    }
    let alive = true;
    setLoading(true);
    load()
      .then((d) => alive && setEstimate(d))
      .catch(() => alive && setEstimate(null))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch, enabled]);
  return { estimate, loading };
}
